var _path, _g, _path2, _g2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivaBlueLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 21,
    fill: "none",
    viewBox: "0 0 14 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.776 12.67c-1.052-.239-1.713-1.285-1.475-2.337.192-.848.91-1.442 1.732-1.515-1.052-.092-1.991.67-2.111 1.726-.122 1.071.648 2.039 1.72 2.16.134.016.266.017.394.006-.086-.008-.173-.021-.26-.04zM12.311 1.374l-1.122 9.881c-.22 1.935-1.697 3.488-3.618 3.805-.179.03-.357.047-.534.055.134.005.269.004.405-.003 1.944-.105 3.582-1.489 4.012-3.388l2.374-10.498c-.547-.124-1.05-.082-1.517.148zM8.472 6.598c-.467-.142-.954-.204-1.44-.185.49.02.976.12 1.44.305v-.12z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__paint0_linear)",
    d: "M6.776 12.67c-1.052-.239-1.713-1.285-1.475-2.337.192-.848.91-1.442 1.732-1.515-1.052-.092-1.991.67-2.111 1.726-.122 1.071.648 2.039 1.72 2.16.134.016.266.017.394.006-.086-.008-.173-.021-.26-.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__paint1_linear)",
    d: "M12.311 1.374l-1.122 9.881c-.22 1.935-1.697 3.488-3.618 3.805-.179.03-.357.047-.534.055.134.005.269.004.405-.003 1.944-.105 3.582-1.489 4.012-3.388l2.374-10.498c-.547-.124-1.05-.082-1.517.148z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__paint2_linear)",
    d: "M8.472 6.598c-.467-.142-.954-.204-1.44-.185.49.02.976.12 1.44.305v-.12z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.642 12.704c-1.072-.121-1.842-1.089-1.72-2.16.106-.939.86-1.646 1.766-1.726-.056-.005-.112-.008-.17-.008-1.078 0-1.953.875-1.953 1.954s.875 1.953 1.953 1.953c.058 0 .116-.003.172-.008l-.048-.005zM8.472 6.872v-.154C7.9 6.49 7.295 6.39 6.695 6.413c.604.024 1.21.175 1.777.46zM10.873.9v9.864c0 1.947-1.293 3.657-3.166 4.189-.337.095-.679.148-1.018.162.29.011.586-.006.881-.055 1.922-.317 3.4-1.87 3.619-3.805L12.404.56C11.83.495 11.322.6 10.873.9z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__paint3_linear)",
    d: "M6.642 12.704c-1.072-.121-1.842-1.089-1.72-2.16.106-.939.86-1.646 1.766-1.726-.056-.005-.112-.008-.17-.008-1.078 0-1.953.875-1.953 1.954s.875 1.953 1.953 1.953c.058 0 .116-.003.172-.008l-.048-.005z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__paint4_linear)",
    d: "M8.472 6.872v-.154C7.9 6.49 7.295 6.39 6.695 6.413c.604.024 1.21.175 1.777.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__paint5_linear)",
    d: "M10.873.9v9.864c0 1.947-1.293 3.657-3.166 4.189-.337.095-.679.148-1.018.162.29.011.586-.006.881-.055 1.922-.317 3.4-1.87 3.619-3.805L12.404.56C11.83.495 11.322.6 10.873.9z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__paint6_linear)",
    d: "M10.872 0c-.733 0-1.33.26-1.8.834-.483.592-.6 1.19-.6 1.922v4.116c-1.74-.873-3.85-.485-5.164.95-1.316 1.437-1.518 3.571-.495 5.228 1.022 1.657 3.02 2.434 4.894 1.903 1.873-.532 3.166-2.242 3.166-4.19V0zM6.518 12.717c-1.078 0-1.953-.874-1.953-1.953 0-1.079.875-1.953 1.953-1.953 1.08 0 1.954.874 1.954 1.953 0 1.079-.875 1.953-1.954 1.953z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__paint7_linear)",
    fillRule: "evenodd",
    d: "M6.914 6.428v2.423c.87.18 1.53.938 1.557 1.855V6.873c-.498-.25-1.026-.397-1.557-.445z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B4CF2",
    d: "M3.272 19.025c.114-.203.272-.365.471-.486.2-.121.42-.182.658-.182.219 0 .429.05.63.151.202.1.368.247.5.438.131.191.2.417.207.676.004.11-.003.215-.02.318h-1.9c.03.126.098.226.202.3.104.073.231.11.381.11.106 0 .193-.014.26-.042.066-.027.126-.063.18-.107l.795.005c-.106.236-.268.427-.487.574-.218.146-.46.22-.727.22-.243 0-.464-.059-.666-.177-.201-.118-.361-.277-.479-.479-.118-.201-.177-.421-.177-.66 0-.236.058-.455.172-.659zm1.754.382c-.05-.12-.132-.216-.243-.29-.111-.073-.231-.11-.361-.11-.144 0-.266.036-.369.108-.102.072-.18.17-.235.292h1.208zM6.194 20.959v-4.066h.666v4.066h-.666zM7.559 18.011c-.077-.077-.115-.171-.115-.284 0-.11.038-.202.115-.28.077-.076.172-.114.284-.114.11 0 .203.038.28.115.076.077.115.17.115.279 0 .113-.039.207-.116.284-.076.077-.17.116-.279.116-.112 0-.207-.039-.284-.116zm-.049.387h.666v2.561H7.51v-2.561zM8.565 18.398h.697l.584 1.685.589-1.685h.696l-.952 2.56h-.666l-.948-2.56zM11.94 20.823c-.2-.118-.361-.278-.48-.481-.12-.203-.18-.424-.18-.663 0-.24.06-.46.18-.664.119-.203.28-.364.48-.481.202-.118.422-.177.661-.177.24 0 .46.059.661.177.202.117.361.278.479.481.118.203.177.424.177.663v1.28h-.666v-.27c-.038.085-.12.158-.246.22-.126.061-.261.092-.405.092-.239 0-.459-.059-.66-.177zm1.133-.666c.123-.128.184-.287.184-.479 0-.19-.061-.35-.184-.478s-.279-.192-.466-.192c-.188 0-.345.064-.472.192-.126.128-.19.287-.19.479 0 .19.064.35.19.478.127.128.284.192.472.192.187 0 .343-.064.466-.192zM2.139 16.986c-.167.136-.167.292-.167.48v1.06c-.52-.294-1.172-.202-1.592.224-.419.425-.5 1.079-.2 1.595.302.515.911.765 1.488.609.576-.156.977-.68.977-1.277v-2.794c-.18 0-.344-.03-.506.103zm-.817 3.351c-.364 0-.66-.295-.66-.66 0-.364.296-.66.66-.66.365 0 .66.296.66.66 0 .365-.295.66-.66.66z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear",
    x1: 5.964,
    x2: 5.964,
    y1: 9.369,
    y2: 13.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0582F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C1DEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint1_linear",
    x1: 10.406,
    x2: 10.406,
    y1: 3.152,
    y2: 17.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0582F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C1DEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint2_linear",
    x1: 7.747,
    x2: 7.747,
    y1: 6.454,
    y2: 6.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0582F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C1DEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint3_linear",
    x1: 5.619,
    x2: 5.619,
    y1: 9.368,
    y2: 13.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0582F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C1DEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint4_linear",
    x1: 7.576,
    x2: 7.576,
    y1: 6.476,
    y2: 6.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0582F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C1DEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint5_linear",
    x1: 9.524,
    x2: 9.524,
    y1: 2.624,
    y2: 17.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0582F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C1DEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint6_linear",
    x1: 6.484,
    x2: 6.484,
    y1: 2.16,
    y2: 17.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0582F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C1DEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint7_linear",
    x1: 9.445,
    x2: 7.249,
    y1: 8.172,
    y2: 8.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#083383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#083383",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivaBlueLogo);
export default __webpack_public_path__ + "static/media/deliva_blue_logo.6271642a95fe7720b1ad8c351b6facce.svg";
export { ForwardRef as ReactComponent };